export enum RestFunctionBodyType {
    Raw = 'raw',
    FormData = 'form-data',
    FormUrlEncoded = 'x-www-form-urlencoded',
}